module.exports = __webpack_public_path__ + "img/klm-logo.bec6fe7b.svg";